import React from 'react';
import logo from '../images/profitlogo.png';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Expert Canadian Tax & Accounting Solutions
              <span className="hero-subtitle">Say Goodbye to Tax Stress</span>
            </h1>
            
            <p className="hero-description">
              Navigate Canada's complex tax system with confidence. Serving individuals and businesses 
              across Canada with professional tax preparation, business incorporation, 
              and comprehensive bookkeeping services.
            </p>
            
            <div className="hero-features">
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Stress-free tax preparation</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Expert Canadian tax knowledge</span>
              </div>
              <div className="feature-item">
                <div className="feature-icon">✓</div>
                <span>Greater Toronto Area specialists</span>
              </div>
            </div>
            
            <div className="hero-cta">
              <button 
                onClick={() => scrollToSection('contact')} 
                className="btn btn-primary hero-btn-primary"
              >
                Contact Us Today
              </button>
              <button 
                onClick={() => scrollToSection('services')} 
                className="btn btn-secondary hero-btn-secondary"
              >
                View Our Services
              </button>
            </div>
          </div>
          
          <div className="hero-image">
            <div className="hero-image-placeholder">
              <div className="image-content">
                <img src={logo} alt="Profit Pioneers Accounting & Bookkeeping Inc." className="hero-logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Trust Indicators */}
      <div className="trust-indicators">
        <div className="container">
          <div className="trust-content">
            <div className="trust-item">
              <div className="trust-number">500+</div>
              <div className="trust-label">Happy Clients</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">7+</div>
              <div className="trust-label">Years Experience</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">100%</div>
              <div className="trust-label">Compliance Rate</div>
            </div>
            <div className="trust-item">
              <div className="trust-number">24/7</div>
              <div className="trust-label">Support Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
